import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class WorkSpaceService {
  constructor(private readonly httpService: AmplifyHttpClient) {}
  getWorkSpaceDetails(workspaceId) {
    const url = `api/workspace/workspace-details/${workspaceId}`;
    return this.httpService.get(url, null).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getWorkSpaceTypes(workspaceId,type) {
    const url = `api/workspace/workspace-config-registers-type/${workspaceId}/${type}`;
    return this.httpService.get(url, null).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
 workSpaceTypeAccess(payload) {
    const url = `api/workspace/workspace-config-registers`;
    return this.httpService.post<any>(url, payload).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response.data;
        }
      })
    );
  }
  getWorkspaceOnboarding(workspaceId) {
    const url = `api/workspace/workspace-onboarding/${workspaceId}`;
    return this.httpService.get(url, null).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
}
